import axios from 'axios'
import { stampOriginsOfMonth, rosterEnteredDayIndexes } from './stampOrigin'

/**
 * 本人の、その月の「手入力・修正した日」の数。提出の確認で使う。
 *
 * 勤務表の画面と同じ2つの口（勤務表の一覧・打刻の記録）を読み、同じ判定
 * （utils/stampOrigin.js）に通す。勤務表の画面と同じく、保存していない日と
 * 今日より後の日は、時刻が空のものとして扱う。
 *
 * **読めなければ 0 を返す。**確認の文が1行減るだけで、提出は止めない。
 *
 * @param {string} yearMonth 「202610」の形
 * @param {Date} [today]
 * @returns {Promise<number>}
 */
export const rosterEnteredDayCount = (yearMonth, today = new Date()) => {
  // 「202610」「2026年10月」「2026/10」のどれでも読む（提出物一覧は「2026年10月」の形で持っている）。
  const read = /^(\d{4})\D{0,2}(\d{1,2})\D?$/.exec(
    String(yearMonth == null ? '' : yearMonth).trim())
  const match = read && Number(read[2]) >= 1 && Number(read[2]) <= 12
    ? [read[0], read[1], read[2].padStart(2, '0')]
    : null
  if (!match) return Promise.resolve(0)
  const year = Number(match[1])
  const month = Number(match[2])
  const origin = process.env.VUE_APP_API_ORIGIN
  const todayKey = today.getFullYear() + '-' +
    String(today.getMonth() + 1).padStart(2, '0') + '-' +
    String(today.getDate()).padStart(2, '0')

  return Promise.all([
    axios.get(origin + '/select', { params: { year, month } }),
    axios.get(origin + '/stamping/events', { params: { year, month } })
  ])
    .then(([roster, stamping]) => {
      const rows = Array.isArray(roster && roster.data) ? roster.data : []
      const data = (stamping && stamping.data) || {}
      const dates = rows.map((_, index) =>
        match[1] + '-' + match[2] + '-' + String(index + 1).padStart(2, '0'))
      const shown = (row, index, key) =>
        (row && row.id != null && dates[index] <= todayKey && row[key]) || ''
      const origins = stampOriginsOfMonth({
        dates,
        events: data.events,
        starts: rows.map((row, index) => shown(row, index, 'start_time')),
        ends: rows.map((row, index) => shown(row, index, 'end_time'))
      })
      return rosterEnteredDayIndexes(origins).length
    })
    .catch(() => 0)
}
